module.exports = __webpack_public_path__ + "img/29.3bc04c35.png";